import { Badge } from "@/components/ui/badge";
import { Tag } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { commonMenuLabels } from "@/i18n";

interface SaleTypeBadgeProps {
  saleType: "auction" | "direct-purchase" | "direct";
  auctionType?: string;
  className?: string;
}

export const SaleTypeBadge = ({ saleType, auctionType, className = "" }: SaleTypeBadgeProps) => {
  const { language } = useLanguage();
  const menuLabels = commonMenuLabels(language);

  const getBadgeContent = () => {
    if (saleType === "auction") {
      return auctionType || menuLabels.auction;
    }
    return menuLabels.directPurchase;
  };

  const getBadgeStyles = () => {
    // Always use the dark-theme look (static), regardless of app theme.
    if (saleType === "auction") {
      return "bg-orange-900/80 text-orange-300 border-orange-700";
    }
    return "bg-green-900/80 text-green-300 border-green-700";
  };

  return (
    <Badge
      variant="outline"
      className={`flex items-center gap-1 flex-shrink-0 ${getBadgeStyles()} ${className}`}
    >
      <Tag className="h-3 w-3" />
      {getBadgeContent()}
    </Badge>
  );
}; 